function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FootprintsGroup = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _FilterGroup = require("../FilterGroup");
var _utils = require("../../utils");
var _FootprintsGroupController = require("./FootprintsGroupController");
var _components = require("../../components");
var _styles = require("../../styles");
var _styles2 = require("./styles");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _locales = require("../../locales");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["item"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var FootprintsGroup = exports.FootprintsGroup = (0, _react.memo)(function (_ref) {
  var _ref$controller = _ref.controller,
    controller = _ref$controller === void 0 ? new _FootprintsGroupController.FootprintsGroupController() : _ref$controller,
    scrollViewRef = _ref.scrollViewRef,
    _ref$selectedFilters = _ref.selectedFilters,
    selectedFilters = _ref$selectedFilters === void 0 ? [] : _ref$selectedFilters,
    onFilterChange = _ref.onFilterChange;
  (0, _useLang.useLang)();
  (0, _locales.useFootprintLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  var _useAnalytics = (0, _utils.useAnalytics)(),
    trackEvent = _useAnalytics.trackEvent,
    trackingEvents = _useAnalytics.trackingEvents;
  var _hasCheckedInitialFilter = (0, _react.useRef)(false);
  var _useScrollTo = (0, _utils.useScrollTo)({
      scrollViewRef: scrollViewRef
    }),
    scrollTo = _useScrollTo.scrollTo;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    footprintDetailPageLinkUrl = _useContext.footprintDetailPageLinkUrl,
    footprintPageLinkUrl = _useContext.footprintPageLinkUrl,
    insightsPageLinkUrl = _useContext.insightsPageLinkUrl,
    householdFootprintPageLinkUrl = _useContext.householdFootprintPageLinkUrl;
  var _controller$useContro = controller.useController(),
    isLoading = _controller$useContro.isLoading,
    footprints = _controller$useContro.footprints,
    statusFilters = _controller$useContro.statusFilters,
    categoryFilters = _controller$useContro.categoryFilters,
    carbonFootprint = _controller$useContro.carbonFootprint;
  var _hasSelectedFilters = selectedFilters.filter(function (item) {
    return !!item;
  }).length > 0;
  var _listRef = (0, _react.useRef)(null);
  var _listY = (0, _react.useRef)(0);
  var _statusFiltersY = (0, _react.useRef)(0);
  var _statusFiltersSlugs = (0, _react.useMemo)(function () {
    return (statusFilters == null ? void 0 : statusFilters.map(function (item) {
      return item.slug;
    })) || [];
  }, [statusFilters]);
  var _categoryFiltersY = (0, _react.useRef)(0);
  var _categoryFiltersSlugs = (0, _react.useMemo)(function () {
    return (categoryFilters == null ? void 0 : categoryFilters.map(function (item) {
      return item.slug;
    })) || [];
  }, [categoryFilters]);
  var _scrollToFilterGroup = (0, _react.useCallback)(function (slug) {
    var _hasStatus = false;
    var _hasCategory = false;
    if (slug) {
      if (_statusFiltersSlugs.includes(slug)) {
        _hasStatus = true;
      }
      if (_categoryFiltersSlugs.includes(slug)) {
        _hasCategory = true;
      }
    } else {
      selectedFilters.forEach(function (filter) {
        if (_statusFiltersSlugs.includes(filter)) {
          _hasStatus = true;
        }
        if (_categoryFiltersSlugs.includes(filter)) {
          _hasCategory = true;
        }
      });
    }
    if (_hasStatus && _hasCategory) {
      scrollTo(_listY.current);
    } else if (_hasStatus) {
      scrollTo(_listY.current + _statusFiltersY.current);
    } else if (_hasCategory) {
      scrollTo(_listY.current + _categoryFiltersY.current);
    }
  }, [_statusFiltersSlugs, _categoryFiltersSlugs, selectedFilters, scrollTo]);
  var _checkInitialFilters = function _checkInitialFilters() {
    if (_hasCheckedInitialFilter.current) return;
    if (_listY.current === 0 || _statusFiltersY.current === 0 || _categoryFiltersY.current === 0) return;
    _hasCheckedInitialFilter.current = true;
    if (_hasSelectedFilters) {
      _scrollToFilterGroup();
    }
  };
  var _onLayout = function _onLayout(_ref2) {
    var y = _ref2.nativeEvent.layout.y;
    if (_listY.current !== y && y > 0) {
      _listY.current = y;
    }
    _checkInitialFilters();
  };
  var _statusFilterGroupOnLayout = function _statusFilterGroupOnLayout(_ref3) {
    var y = _ref3.nativeEvent.layout.y;
    if (_statusFiltersY.current !== y && y > 0) {
      _statusFiltersY.current = y;
    }
    _checkInitialFilters();
  };
  var _categoryFilterGroupOnLayout = function _categoryFilterGroupOnLayout(_ref4) {
    var y = _ref4.nativeEvent.layout.y;
    if (_categoryFiltersY.current !== y && y > 0) {
      _categoryFiltersY.current = y;
    }
    _checkInitialFilters();
  };
  var _onFilterChange = (0, _react.useCallback)(function (_ref5) {
    var slug = _ref5.slug,
      _ref5$isToggle = _ref5.isToggle,
      isToggle = _ref5$isToggle === void 0 ? false : _ref5$isToggle;
    var _selectedFilters = (0, _toConsumableArray2["default"])(selectedFilters);
    var _index = _selectedFilters.findIndex(function (item) {
      return item === slug;
    });
    if (isToggle && _index > -1) {
      _selectedFilters.splice(_index, 1);
    } else if (_index === -1) {
      _selectedFilters.push(slug);
    }
    onFilterChange == null ? void 0 : onFilterChange(_selectedFilters);
  }, [onFilterChange, selectedFilters]);
  var _statusFiltersOnPress = function _statusFiltersOnPress(slug) {
    trackEvent({
      eventName: trackingEvents.footprintFilter,
      props: {
        type: 'status',
        source: 'filter',
        slug: slug,
        toggled: selectedFilters.includes(slug)
      }
    });
    _onFilterChange({
      slug: slug,
      isToggle: true
    });
  };
  var _categoryFiltersOnPress = function _categoryFiltersOnPress(slug) {
    trackEvent({
      eventName: trackingEvents.stepFilter,
      props: {
        type: 'category',
        source: 'filter',
        slug: slug,
        toggled: selectedFilters.includes(slug)
      }
    });
    _onFilterChange({
      slug: slug,
      isToggle: true
    });
  };
  var _categoryPillOnPress = (0, _react.useCallback)(function (slug) {
    var _isCatgegory = !!(categoryFilters != null && categoryFilters.find(function (item) {
      return item.slug === slug;
    }));
    var _slugType = _isCatgegory ? 'category' : 'status';
    trackEvent({
      eventName: trackingEvents.stepFilter,
      props: {
        source: 'category',
        type: _slugType,
        slug: slug,
        toggled: selectedFilters.includes(slug)
      }
    });
    _scrollToFilterGroup(slug);
    _onFilterChange({
      slug: slug
    });
  }, [_onFilterChange, _scrollToFilterGroup, categoryFilters, selectedFilters, trackEvent, trackingEvents.stepFilter]);
  var ItemTemplate = (0, _react.useCallback)(function (_ref6) {
    var item = _ref6.item,
      props = (0, _objectWithoutProperties2["default"])(_ref6, _excluded);
    var _primaryActionLink = footprintDetailPageLinkUrl ? (0, _utils.ReplaceParam)(footprintDetailPageLinkUrl, item.param) : undefined;
    return (0, _jsxRuntime.jsx)(_components.FootprintCard, Object.assign({
      title: item.name,
      description: item.summary,
      footprintParam: item.param,
      categoryPill: {
        slug: item.section,
        label: t("footprint:category.".concat(item.section)),
        onPress: _categoryPillOnPress
      },
      isCentred: bp.tablet,
      isHighlighted: !item.existing,
      hideSuppress: item.existing,
      primaryActionLink: _primaryActionLink
    }, props));
  }, [_categoryPillOnPress, bp.tablet, footprintDetailPageLinkUrl, t]);
  var _filteredFootprints = (0, _react.useMemo)(function () {
    if (!_hasSelectedFilters) {
      return footprints;
    }
    var _selectedStatusFilters = statusFilters.filter(function (filter) {
      return selectedFilters.includes(filter.slug);
    }).map(function (item) {
      return item.slug;
    });
    var _selectedCategoryFilters = categoryFilters.filter(function (filter) {
      return selectedFilters.includes(filter.slug);
    }).map(function (item) {
      return item.slug;
    });
    return footprints == null ? void 0 : footprints.filter(function (item) {
      var _hasStatus = false;
      var _hasCategory = false;
      if (_selectedStatusFilters.length === 0) {
        _hasStatus = true;
      } else {
        if (_selectedStatusFilters.includes(_FootprintsGroupController.StatusFilters.needsInformation)) {
          if (item.existing === false) {
            _hasStatus = true;
          }
        }
        if (item.existing) {
          if (_selectedStatusFilters.includes(_FootprintsGroupController.StatusFilters.requiresUpdating)) {
            var _sixMonthsAgo = new Date();
            _sixMonthsAgo.setMonth(_sixMonthsAgo.getMonth() - 6);
            var _createdAt = new Date(item.createdAt);
            if (_createdAt < _sixMonthsAgo) {
              _hasStatus = true;
            }
          }
          if (_selectedStatusFilters.includes(_FootprintsGroupController.StatusFilters.recentlyUpdated)) {
            var _sixMonthsAgo2 = new Date();
            _sixMonthsAgo2.setMonth(_sixMonthsAgo2.getMonth() - 6);
            var _createdAt2 = new Date(item.createdAt);
            if (_createdAt2 >= _sixMonthsAgo2) {
              _hasStatus = true;
            }
          }
          if (_selectedStatusFilters.includes(_FootprintsGroupController.StatusFilters.doesntApply)) {
            if (item.applicable === false) {
              _hasStatus = true;
            }
          }
        }
      }
      if (_selectedCategoryFilters.length === 0) {
        _hasCategory = true;
      } else {
        _hasCategory = _selectedCategoryFilters.includes(item.section);
      }
      return _hasStatus && _hasCategory;
    });
  }, [_hasSelectedFilters, categoryFilters, footprints, selectedFilters, statusFilters]);
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {
      testID: "ActivityIndicatorIsLoading"
    });
  }
  return (0, _jsxRuntime.jsx)(_utils.AnalyticsSourceContext.Provider, {
    value: {
      source: 'FootprintsGroup'
    },
    children: (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: [styles.container, styles.container_noHeader],
      testID: "FootprintsGroup",
      onLayout: _onLayout,
      ref: _listRef,
      children: [(0, _jsxRuntime.jsx)(_components.Heading, {
        level: 1,
        style: styles.heading,
        children: t('footprint:title')
      }), (0, _jsxRuntime.jsx)(_components.TabNavigation, {
        style: styles.tabs,
        items: [{
          label: t('footprint:subNavigation.footprints'),
          href: footprintPageLinkUrl,
          active: true
        }, {
          label: t('footprint:subNavigation.insights'),
          href: insightsPageLinkUrl
        }]
      }), (0, _jsxRuntime.jsx)(_components.IntroText, {
        style: styles.introText,
        children: t('footprintsGroup:intro', {
          carbonFootprint: carbonFootprint == null ? void 0 : carbonFootprint.toLocaleString()
        })
      }), statusFilters && (0, _jsxRuntime.jsx)(_FilterGroup.FilterGroup, {
        testID: "FilterGroupStatus",
        title: t('footprintsGroup:filters.status.title'),
        onPress: _statusFiltersOnPress,
        items: statusFilters,
        style: styles.filterGroup,
        selectedItems: selectedFilters,
        onLayout: _statusFilterGroupOnLayout
      }), categoryFilters && (0, _jsxRuntime.jsx)(_FilterGroup.FilterGroup, {
        testID: "FilterGroupCategory",
        title: t('footprintsGroup:filters.category.title'),
        onPress: _categoryFiltersOnPress,
        items: categoryFilters,
        style: styles.filterGroup,
        selectedItems: selectedFilters,
        onLayout: _categoryFilterGroupOnLayout
      }), (0, _jsxRuntime.jsx)(_components.CardList, {
        style: styles.list,
        emptyMessage: t('footprintsGroup:list.emptyMessage'),
        items: _filteredFootprints,
        ItemTemplate: ItemTemplate,
        testID: "FootprintsGroupList"
      }), (0, _jsxRuntime.jsx)(_components.CTAMessage, {
        heading: t('footprintsGroup:household.title'),
        text: t('footprintsGroup:household.text'),
        linkLabel: t('footprintsGroup:household.buttonLabel'),
        linkUrl: householdFootprintPageLinkUrl
      })]
    })
  });
});